// Permission checking utility functions (ERP 1/0 permissions)
import { getErpAuthState, getErpPermissions } from "../erpClient";

// List of all available permissions/pages (including standardized action codes: _VIEW, _ADD, _EDIT, _DELETE)
export const PERMISSIONS = {
  // 1. Dashboard
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  DASHBOARD: "DASHBOARD_VIEW",

  // 2. Daily Price
  DAILY_PRICE_ADD: "DAILY_PRICE_ADD",
  DAILY_PRICE_VIEW: "DAILY_PRICE_VIEW",
  DAILY_PRICE: "DAILY_PRICE_VIEW",

  // 3. Metal Group
  METAL_GROUP_ADD: "METAL_GROUP_ADD",
  METAL_GROUP_EDIT: "METAL_GROUP_EDIT",
  METAL_GROUP_VIEW: "METAL_GROUP_VIEW",
  METAL_GROUP: "METAL_GROUP_VIEW",

  // 4. Item Category & Product Assorting
  ITEM_CATEGORY_ADD: "ITEM_CATEGORY_ADD",
  ITEM_CATEGORY_EDIT: "ITEM_CATEGORY_EDIT",
  ITEM_CATEGORY_VIEW: "ITEM_CATEGORY_VIEW",
  ITEM_CATEGORY: "ITEM_CATEGORY_VIEW",
  PRODUCT_ASSORTING_ADD: "PRODUCT_ASSORTING_ADD",
  PRODUCT_ASSORTING_EDIT: "PRODUCT_ASSORTING_EDIT",
  PRODUCT_ASSORTING_VIEW: "PRODUCT_ASSORTING_VIEW",
  PRODUCT_ASSORTING: "PRODUCT_ASSORTING_VIEW",
  PRODUCT_ASSORTING_TABLE: "PRODUCT_ASSORTING_VIEW",

  // 5. Product Group & Opening Pool
  PRODUCT_GROUP_ADD: "PRODUCT_GROUP_ADD",
  PRODUCT_GROUP_EDIT: "PRODUCT_GROUP_EDIT",
  PRODUCT_GROUP_VIEW: "PRODUCT_GROUP_VIEW",
  PRODUCT_GROUP: "PRODUCT_GROUP_VIEW",

  // 6. Bank
  BANK_ADD: "BANK_ADD",
  BANK_EDIT: "BANK_EDIT",
  BANK_VIEW: "BANK_VIEW",
  BANK: "BANK_VIEW",

  // 7. Capital Investments
  CAPITAL_INVESTMENT_ADD: "CAPITAL_INVESTMENT_ADD",
  CAPITAL_INVESTMENT_EDIT: "CAPITAL_INVESTMENT_EDIT",
  CAPITAL_INVESTMENT_VIEW: "CAPITAL_INVESTMENT_VIEW",
  CAPITAL_INVESTMENT_TABLE: "CAPITAL_INVESTMENT_VIEW",
  EDIT_CAPITAL_INVESTMENT: "CAPITAL_INVESTMENT_EDIT",

  // 8. Sales Target
  SALES_TARGET_ADD: "SALES_TARGET_ADD",
  SALES_TARGET_EDIT: "SALES_TARGET_EDIT",
  SALES_TARGET_VIEW: "SALES_TARGET_VIEW",

  // 9. HRMS
  HRMS_HOLIDAY_ADD: "HRMS_HOLIDAY_ADD",
  HRMS_HOLIDAY_EDIT: "HRMS_HOLIDAY_EDIT",
  HRMS_HOLIDAY_VIEW: "HRMS_HOLIDAY_VIEW",
  HRMS_PROFILE_ADD: "HRMS_PROFILE_ADD",
  HRMS_PROFILE_EDIT: "HRMS_PROFILE_EDIT",
  HRMS_PROFILE_VIEW: "HRMS_PROFILE_VIEW",
  HRMS_INCENTIVE_ADD: "HRMS_INCENTIVE_ADD",
  HRMS_INCENTIVE_EDIT: "HRMS_INCENTIVE_EDIT",
  HRMS_INCENTIVE_VIEW: "HRMS_INCENTIVE_VIEW",
  HRMS_INCENTIVE_APPROVE: "HRMS_INCENTIVE_EDIT",
  HRMS_OVERTIME_ADD: "HRMS_OVERTIME_ADD",
  HRMS_OVERTIME_EDIT: "HRMS_OVERTIME_EDIT",
  HRMS_OVERTIME_VIEW: "HRMS_OVERTIME_VIEW",
  HRMS_OVERTIME_APPROVE: "HRMS_OVERTIME_EDIT",
  HRMS_ADVANCE_ADD: "HRMS_ADVANCE_ADD",
  HRMS_ADVANCE_EDIT: "HRMS_ADVANCE_EDIT",
  HRMS_ADVANCE_VIEW: "HRMS_ADVANCE_VIEW",
  HRMS_PAYROLL_ADD: "HRMS_PAYROLL_ADD",
  HRMS_PAYROLL_EDIT: "HRMS_PAYROLL_EDIT",
  HRMS_PAYROLL_VIEW: "HRMS_PAYROLL_VIEW",
  HRMS_PAYROLL_RUN: "HRMS_PAYROLL_ADD",
  HRMS_PAYROLL_LOCK: "HRMS_PAYROLL_EDIT",
  HRMS_ATTENDANCE_ADD: "HRMS_ATTENDANCE_ADD",
  HRMS_ATTENDANCE_EDIT: "HRMS_ATTENDANCE_EDIT",
  HRMS_ATTENDANCE_VIEW: "HRMS_ATTENDANCE_VIEW",

  // 10. Customer
  CUSTOMER_ADD: "CUSTOMER_ADD",
  CUSTOMER_EDIT: "CUSTOMER_EDIT",
  CUSTOMER_VIEW: "CUSTOMER_VIEW",
  CUSTOMER: "CUSTOMER_VIEW",

  // 11. Supplier / Karigar
  SUPPLIER_ADD: "SUPPLIER_ADD",
  SUPPLIER_EDIT: "SUPPLIER_EDIT",
  SUPPLIER_VIEW: "SUPPLIER_VIEW",
  SUPPLIER: "SUPPLIER_VIEW",
  SUPPLIER_TABLE: "SUPPLIER_VIEW",
  KARIGAR: "SUPPLIER_VIEW",

  // 12. Supplier / Karigar Settlement
  SUPPLIER_SETTLEMENT_ADD: "SUPPLIER_SETTLEMENT_ADD",
  SUPPLIER_SETTLEMENT_EDIT: "SUPPLIER_SETTLEMENT_EDIT",
  SUPPLIER_SETTLEMENT_VIEW: "SUPPLIER_SETTLEMENT_VIEW",

  // 13. Karigar Conversion
  KARIGAR_CONVERSION_ADD: "KARIGAR_CONVERSION_ADD",
  KARIGAR_CONVERSION_EDIT: "KARIGAR_CONVERSION_EDIT",
  KARIGAR_CONVERSION_VIEW: "KARIGAR_CONVERSION_VIEW",
  KARIGAR_CONVERSION: "KARIGAR_CONVERSION_ADD",

  // 14. Tenant & Branch
  TENANT_ADD: "TENANT_ADD",
  TENANT_EDIT: "TENANT_EDIT",
  TENANT_VIEW: "TENANT_VIEW",
  TENANT_TABLE: "TENANT_VIEW",
  EDIT_TENANT: "TENANT_EDIT",
  BRANCH_ADD: "BRANCH_ADD",
  BRANCH_EDIT: "BRANCH_EDIT",
  BRANCH_VIEW: "BRANCH_VIEW",
  BRANCH_TABLE: "BRANCH_VIEW",
  EDIT_BRANCH: "BRANCH_EDIT",

  // 15. Role
  ROLE_ADD: "ROLE_ADD",
  ROLE_EDIT: "ROLE_EDIT",
  ROLE_VIEW: "ROLE_VIEW",

  // 16. Employee
  EMPLOYEE_ADD: "EMPLOYEE_ADD",
  EMPLOYEE_EDIT: "EMPLOYEE_EDIT",
  EMPLOYEE_VIEW: "EMPLOYEE_VIEW",
  EMPLOYEE: "EMPLOYEE_VIEW",

  // 17. Walk-in & Customer Assign
  WALKIN_ADD: "WALKIN_ADD",
  CUSTOMER_ARRIVAL: "WALKIN_ADD",
  TEST_CUSTOMER_FORM: "WALKIN_ADD",
  CUSTOMER_ASSIGN_ADD: "CUSTOMER_ASSIGN_ADD",
  CUSTOMER_ASSIGN_VIEW: "CUSTOMER_ASSIGN_VIEW",
  CUSTOMER_ASSIGN: "CUSTOMER_ASSIGN_VIEW",

  // 18. Order Queue
  ORDER_QUEUE_VIEW: "ORDER_QUEUE_VIEW",
  ORDER_QUEUE: "ORDER_QUEUE_VIEW",

  // 19. Cash & Bank Popups
  CASH_BANK_ADD: "CASH_BANK_ADD",
  CASH_BANK_EDIT: "CASH_BANK_EDIT",
  CASH_BANK_VIEW: "CASH_BANK_VIEW",
  CASHBOOK_SETTLEMENT: "CASH_BANK_VIEW",
  BANKBOOK_SETTLEMENT: "CASH_BANK_VIEW",

  // 20. Purchase & Rate-Cut
  PURCHASE_ADD: "PURCHASE_ADD",
  PURCHASE_EDIT: "PURCHASE_EDIT",
  PURCHASE_VIEW: "PURCHASE_VIEW",
  PURCHASE_TABLE: "PURCHASE_VIEW",
  ADD_PURCHASE: "PURCHASE_ADD",
  EDIT_PURCHASE: "PURCHASE_EDIT",
  RATECUT_ADD: "RATECUT_ADD",
  RATECUT_EDIT: "RATECUT_EDIT",
  RATECUT_VIEW: "RATECUT_VIEW",
  RATECUT_view: "RATECUT_view",

  // 21. Old Metal Purchase
  OLD_METAL_PURCHASE_ADD: "OLD_METAL_PURCHASE_ADD",
  OLD_METAL_PURCHASE_EDIT: "OLD_METAL_PURCHASE_EDIT",
  OLD_METAL_PURCHASE_VIEW: "OLD_METAL_PURCHASE_VIEW",
  METAL_PURCHASE_TABLE: "OLD_METAL_PURCHASE_VIEW",
  ADD_OLD_PURCHASE: "OLD_METAL_PURCHASE_ADD",
  EDIT_OLD_PURCHASE: "OLD_METAL_PURCHASE_EDIT",
  OLD_PURCHASE_PDF: "OLD_METAL_PURCHASE_VIEW",

  // 22. Sales
  SALES_ADD: "SALES_ADD",
  SALES_EDIT: "SALES_EDIT",
  SALES_VIEW: "SALES_VIEW",
  SALES_DELETE: "SALES_DELETE",
  SALES: "SALES_VIEW",
  INVOICE: "SALES_VIEW",
  EDIT_INVOICE: "SALES_EDIT",
  SALES_GST_PORTAL_ADD: "SALES_GST_PORTAL_ADD",

  // 22b. Wholesale — ERP codes (ids 169–172)
  // WHSALE_ADD=169, WHSALE_EDIT=170, WHSALE_VIEW=171, WHSALE_DELETE=172
  WHSALE_ADD: "WHSALE_ADD",
  WHSALE_EDIT: "WHSALE_EDIT",
  WHSALE_VIEW: "WHSALE_VIEW",
  WHSALE_DELETE: "WHSALE_DELETE",
  /** @deprecated use WHSALE_VIEW */
  WHSALE: "WHSALE_VIEW",
  /** @deprecated use WHSALE_VIEW */
  WHINVOICE: "WHSALE_VIEW",
  /** @deprecated use WHSALE_EDIT */
  EDIT_WHSALE: "WHSALE_EDIT",

  // 23. Custom Order
  CUSTOM_ORDER_ADD: "CUSTOM_ORDER_ADD",
  CUSTOM_ORDER_EDIT: "CUSTOM_ORDER_EDIT",
  CUSTOM_ORDER_VIEW: "CUSTOM_ORDER_VIEW",
  CUSTOM_ORDER_ENTRY: "CUSTOM_ORDER_ADD",
  CUSTOM_ORDER_ENTRY_TABLE: "CUSTOM_ORDER_VIEW",
  EDIT_CUSTOM_ORDER_ENTRY: "CUSTOM_ORDER_EDIT",
  ORDER_CANCEL: "CUSTOM_ORDER_EDIT",

  // 24. Repairing Order
  REPAIRING_ORDER_ADD: "REPAIRING_ORDER_ADD",
  REPAIRING_ORDER_EDIT: "REPAIRING_ORDER_EDIT",
  REPAIRING_ORDER_VIEW: "REPAIRING_ORDER_VIEW",
  REPAIRING_ORDER: "REPAIRING_ORDER_VIEW",
  REPAIRING_ORDER_ENTRY: "REPAIRING_ORDER_ADD",
  EDIT_REPAIRING_ORDER: "REPAIRING_ORDER_EDIT",
  REPAIRING_SALES: "REPAIRING_ORDER_VIEW",

  // 25. Jangad
  JANGAD_ADD: "JANGAD_ADD",
  JANGAD_EDIT: "JANGAD_EDIT",
  JANGAD_VIEW: "JANGAD_VIEW",
  JANGAD: "JANGAD_VIEW",
  ADD_JANGAD: "JANGAD_ADD",
  EDIT_JANGAD: "JANGAD_EDIT",

  // 26. Stock Check & Product Search
  STOCK_CHECK_VIEW: "STOCK_CHECK_VIEW",
  PRODUCT_SEARCH_VIEW: "PRODUCT_SEARCH_VIEW",

  // 27. Refinery
  REFINERY_ADD: "REFINERY_ADD",
  REFINERY_EDIT: "REFINERY_EDIT",
  REFINERY_VIEW: "REFINERY_VIEW",
  REFINERY: "REFINERY_VIEW",
  ADD_REFINERY: "REFINERY_ADD",
  EDIT_REFINERY: "REFINERY_EDIT",

  // 28. Metal Transfer
  METAL_TRANSFER_VIEW: "METAL_TRANSFER_VIEW",

  // 29. Leads & Reminders
  LEADS_ADD: "LEADS_ADD",
  LEADS_EDIT: "LEADS_EDIT",
  LEADS_VIEW: "LEADS_VIEW",
  REMINDERS_VIEW: "REMINDERS_VIEW",

  // 30. Customer Settlement
  CUSTOMER_SETTLEMENT_ADD: "CUSTOMER_SETTLEMENT_ADD",
  CUSTOMER_SETTLEMENT_EDIT: "CUSTOMER_SETTLEMENT_EDIT",
  CUSTOMER_SETTLEMENT_VIEW: "CUSTOMER_SETTLEMENT_VIEW",
  ADD_SETTLEMENT: "CUSTOMER_SETTLEMENT_ADD",

  // 31. Products / Stock
  PRODUCT_ADD: "PRODUCT_ADD",
  PRODUCT_EDIT: "PRODUCT_EDIT",
  PRODUCT_VIEW: "PRODUCT_VIEW",
  STOCK: "PRODUCT_ADD",
  BULK_STOCK: "PRODUCT_ADD",
  STOCK_TABLE: "PRODUCT_VIEW",
  EDIT_STOCK: "PRODUCT_EDIT",

  // 32. Ledgers (View Only)
  ROJMEL_VIEW: "ROJMEL_VIEW",
  OVERALL_LEDGER: "OVERALL_LEDGER",
  SALES_LEDGER: "SALES_LEDGER",
  PURCHASE_LEDGER: "PURCHASE_LEDGER",
  CUSTOMER_LEDGER: "CUSTOMER_LEDGER",
  KARIGAR_LEDGER: "KARIGAR_LEDGER",
  URD_LEDGER: "URD_LEDGER",
  BANK_LEDGER: "BANK_LEDGER",

  // 33. Girvi / Dihran
  GIRVI_DASHBOARD_VIEW: "GIRVI_DASHBOARD_VIEW",
  GIRVI_ADD: "GIRVI_ADD",
  GIRVI_EDIT: "GIRVI_EDIT",
  GIRVI_VIEW: "GIRVI_VIEW",
  GIRVI: "GIRVI_VIEW",
  GIRVITABLE: "GIRVI_VIEW",
  ADDGIRVI: "GIRVI_ADD",
  EDITGIRVI: "GIRVI_EDIT",
  GIRVI_QUICK_PAYMENT_VIEW: "GIRVI_QUICK_PAYMENT_VIEW",
  GIRVIQUICKPAYMENT: "GIRVI_QUICK_PAYMENT_VIEW",
  GIRVI_BANK_ADD: "GIRVI_BANK_ADD",
  GIRVI_BANK_EDIT: "GIRVI_BANK_EDIT",
  GIRVI_BANK_VIEW: "GIRVI_BANK_VIEW",
  GIRVIBANKDETAILS: "GIRVI_BANK_VIEW",
  GIRVI_BANK_LEDGER_VIEW: "GIRVI_BANK_LEDGER_VIEW",
  GIRVIBANKLEDGER: "GIRVI_BANK_LEDGER_VIEW",

  // 33b. Reverse Girvi / Reverse Dihran — ERP codes (send these exactly)
  REVERSE_GIRVI_DASHBOARD_VIEW: "REVERSE_GIRVI_DASHBOARD_VIEW",
  REVERSE_GIRVI_ADD: "REVERSE_GIRVI_ADD",
  REVERSE_GIRVI_EDIT: "REVERSE_GIRVI_EDIT",
  REVERSE_GIRVI_VIEW: "REVERSE_GIRVI_VIEW",
  REVERSE_GIRVI_QUICK_PAYMENT_VIEW: "REVERSE_GIRVI_QUICK_PAYMENT_VIEW",
  // Slug aliases → same ERP codes (do not invent extra codes)
  REVERSE_GIRVI: "REVERSE_GIRVI_DASHBOARD_VIEW",
  REVERSE_GIRVI_TABLE: "REVERSE_GIRVI_VIEW",
  ADD_REVERSE_GIRVI: "REVERSE_GIRVI_ADD",
  EDIT_REVERSE_GIRVI: "REVERSE_GIRVI_EDIT",
  REVERSE_GIRVI_QUICK_PAYMENT: "REVERSE_GIRVI_QUICK_PAYMENT_VIEW",

  // 34. WhatsApp
  WHATSAPP: "WHATSAPP_DASHBOARD",
  WHATSAPP_DASHBOARD: "WHATSAPP_DASHBOARD",
  WHATSAPP_INBOX: "WHATSAPP_INBOX",
  WHATSAPP_CAMPAIGN_ADD: "WHATSAPP_CAMPAIGN_ADD",
  WHATSAPP_CAMPAIGN: "WHATSAPP_CAMPAIGN",
  WHATSAPP_TEMPLATE_ADD: "WHATSAPP_TEMPLATE_ADD",
  WHATSAPP_TEMPLATE: "WHATSAPP_TEMPLATE",
  WHATSAPP_PHONEBOOK_ADD: "WHATSAPP_PHONEBOOK_ADD",
  WHATSAPP_PHONEBOOK: "WHATSAPP_PHONEBOOK",

  // 35. Shop Expense & Bill Type
  SHOP_EXPENSE_TABLE: "SHOP_EXPENSE_TABLE",
  ADD_SHOP_EXPENSE: "ADD_SHOP_EXPENSE",
  EDIT_SHOP_EXPENSE: "EDIT_SHOP_EXPENSE",
  BILL_TYPE: "BILL_TYPE",

  // 36. Scheme
  SCHEME_PLAN_ADD: "SCHEME_PLAN_ADD",
  SCHEME_PLAN_EDIT: "SCHEME_PLAN_EDIT",
  SCHEME_PLAN_VIEW: "SCHEME_PLAN_VIEW",
  SCHEME_ADD: "SCHEME_ADD",
  SCHEME_EDIT: "SCHEME_EDIT",
  SCHEME_VIEW: "SCHEME_VIEW",

  // 37. Other Charges
  OTHER_CHARGE_ADD: "OTHER_CHARGE_ADD",
  OTHER_CHARGE_EDIT: "OTHER_CHARGE_EDIT",
  OTHER_CHARGE_VIEW: "OTHER_CHARGE_VIEW",
  OTHER_CHARGE: "OTHER_CHARGE_VIEW",
};

/** Rojmel (day book) — primary + backend alias permissions. */
export const ROJMEL_ROUTE_ANY_PERMISSIONS = [
  PERMISSIONS.ROJMEL_VIEW,
  PERMISSIONS.OVERALL_LEDGER,
  PERMISSIONS.CASH_BANK_VIEW,
  PERMISSIONS.CUSTOMER_LEDGER,
];

/** Any HRMS permission — used for route + sidebar visibility. */
export const HRMS_ROUTE_ANY_PERMISSIONS = [
  PERMISSIONS.HRMS_HOLIDAY_VIEW,
  PERMISSIONS.HRMS_HOLIDAY_ADD,
  PERMISSIONS.HRMS_HOLIDAY_EDIT,
  PERMISSIONS.HRMS_PROFILE_VIEW,
  PERMISSIONS.HRMS_PROFILE_ADD,
  PERMISSIONS.HRMS_PROFILE_EDIT,
  PERMISSIONS.HRMS_INCENTIVE_VIEW,
  PERMISSIONS.HRMS_INCENTIVE_ADD,
  PERMISSIONS.HRMS_INCENTIVE_EDIT,
  PERMISSIONS.HRMS_OVERTIME_VIEW,
  PERMISSIONS.HRMS_OVERTIME_ADD,
  PERMISSIONS.HRMS_OVERTIME_EDIT,
  PERMISSIONS.HRMS_ADVANCE_VIEW,
  PERMISSIONS.HRMS_ADVANCE_ADD,
  PERMISSIONS.HRMS_ADVANCE_EDIT,
  PERMISSIONS.HRMS_PAYROLL_VIEW,
  PERMISSIONS.HRMS_PAYROLL_ADD,
  PERMISSIONS.HRMS_PAYROLL_EDIT,
  PERMISSIONS.HRMS_ATTENDANCE_VIEW,
  PERMISSIONS.HRMS_ATTENDANCE_ADD,
  PERMISSIONS.HRMS_ATTENDANCE_EDIT,
];

// Fallback aliases for backward compatibility between old slug/keys and new action keys
const PERMISSION_FALLBACKS = {
  // Legacy -> New
  DASHBOARD: ["DASHBOARD_VIEW"],
  DAILY_PRICE: ["DAILY_PRICE_VIEW", "DAILY_PRICE_ADD"],
  CUSTOMER: ["CUSTOMER_VIEW", "CUSTOMER_ADD", "CUSTOMER_EDIT"],
  BANK: ["BANK_VIEW", "BANK_ADD", "BANK_EDIT"],
  SUPPLIER: ["SUPPLIER_VIEW", "SUPPLIER_ADD", "SUPPLIER_EDIT"],
  KARIGAR: ["SUPPLIER_VIEW", "SUPPLIER_ADD", "SUPPLIER_EDIT"],
  METAL_GROUP: ["METAL_GROUP_VIEW", "METAL_GROUP_ADD", "METAL_GROUP_EDIT"],
  ITEM_CATEGORY: ["ITEM_CATEGORY_VIEW", "ITEM_CATEGORY_ADD", "ITEM_CATEGORY_EDIT"],
  OTHER_CHARGE: ["OTHER_CHARGE_VIEW", "OTHER_CHARGE_ADD", "OTHER_CHARGE_EDIT"],
  PRODUCT_GROUP: ["PRODUCT_GROUP_VIEW", "PRODUCT_GROUP_ADD", "PRODUCT_GROUP_EDIT"],
  PRODUCT_ASSORTING: ["PRODUCT_ASSORTING_VIEW", "PRODUCT_ASSORTING_ADD", "PRODUCT_ASSORTING_EDIT"],
  PRODUCT_ASSORTING_TABLE: ["PRODUCT_ASSORTING_VIEW"],
  STOCK: ["PRODUCT_ADD", "PRODUCT_VIEW"],
  BULK_STOCK: ["PRODUCT_ADD", "PRODUCT_VIEW"],
  STOCK_TABLE: ["PRODUCT_VIEW"],
  EDIT_STOCK: ["PRODUCT_EDIT"],
  PURCHASE: ["PURCHASE_VIEW"],
  PURCHASE_TABLE: ["PURCHASE_VIEW"],
  ADD_PURCHASE: ["PURCHASE_ADD"],
  EDIT_PURCHASE: ["PURCHASE_EDIT"],
  RATECUT: ["RATECUT_VIEW", "RATECUT_view", "RATECUT_ADD", "RATECUT_EDIT"],
  RATE_CUT: ["RATECUT_VIEW", "RATECUT_view", "RATECUT_ADD", "RATECUT_EDIT"],
  RATECUT_VIEW: ["RATECUT_view", "RATECUT_VIEW"],
  RATECUT_view: ["RATECUT_VIEW", "RATECUT_view"],
  RATECUT_ADD: ["RATECUT_ADD"],
  RATECUT_EDIT: ["RATECUT_EDIT"],
  SALES: ["SALES_VIEW", "SALES_ADD"],
  INVOICE: ["SALES_VIEW"],
  EDIT_INVOICE: ["SALES_EDIT"],
  // Alias keys → official ERP wholesale codes (169–172)
  WHSALE: ["WHSALE_VIEW", "WHSALE_ADD"],
  WHINVOICE: ["WHSALE_VIEW"],
  EDIT_WHSALE: ["WHSALE_EDIT"],
  CUSTOM_ORDER_ENTRY: ["CUSTOM_ORDER_ADD", "CUSTOM_ORDER_VIEW"],
  CUSTOM_ORDER_ENTRY_TABLE: ["CUSTOM_ORDER_VIEW"],
  EDIT_CUSTOM_ORDER_ENTRY: ["CUSTOM_ORDER_EDIT"],
  REPAIRING_ORDER: ["REPAIRING_ORDER_VIEW"],
  REPAIRING_ORDER_ENTRY: ["REPAIRING_ORDER_ADD"],
  EDIT_REPAIRING_ORDER: ["REPAIRING_ORDER_EDIT"],
  JANGAD: ["JANGAD_VIEW"],
  ADD_JANGAD: ["JANGAD_ADD"],
  EDIT_JANGAD: ["JANGAD_EDIT"],
  METAL_PURCHASE_TABLE: ["OLD_METAL_PURCHASE_VIEW"],
  ADD_OLD_PURCHASE: ["OLD_METAL_PURCHASE_ADD"],
  EDIT_OLD_PURCHASE: ["OLD_METAL_PURCHASE_EDIT"],
  REFINERY: ["REFINERY_VIEW"],
  ADD_REFINERY: ["REFINERY_ADD"],
  EDIT_REFINERY: ["REFINERY_EDIT"],
  CASHBOOK_SETTLEMENT: ["CASH_BANK_VIEW", "CASH_BANK_ADD"],
  BANKBOOK_SETTLEMENT: ["CASH_BANK_VIEW", "CASH_BANK_ADD"],
  ADD_SETTLEMENT: ["SUPPLIER_SETTLEMENT_ADD"],
  EMPLOYEE: ["EMPLOYEE_VIEW", "EMPLOYEE_EDIT"],
  CUSTOMER_ARRIVAL: ["WALKIN_ADD"],
  TEST_CUSTOMER_FORM: ["WALKIN_ADD"],
  CUSTOMER_ASSIGN: ["CUSTOMER_ASSIGN_VIEW"],
  ORDER_QUEUE: ["ORDER_QUEUE_VIEW"],
  GIRVI: ["GIRVI_VIEW"],
  GIRVI_TABLE: ["GIRVI_VIEW"],
  ADD_GIRVI: ["GIRVI_ADD"],
  EDIT_GIRVI: ["GIRVI_EDIT"],
  GIRVI_QUICK_PAYMENT: ["GIRVI_QUICK_PAYMENT_VIEW"],
  GIRVI_BANK_DETAILS: ["GIRVI_BANK_VIEW"],
  GIRVI_BANK_LEDGER: ["GIRVI_BANK_LEDGER_VIEW"],
  REVERSE_GIRVI_DASHBOARD_VIEW: ["REVERSE_GIRVI"],
  REVERSE_GIRVI_VIEW: ["REVERSE_GIRVI_TABLE"],
  REVERSE_GIRVI_ADD: ["ADD_REVERSE_GIRVI"],
  REVERSE_GIRVI_EDIT: ["EDIT_REVERSE_GIRVI"],
  REVERSE_GIRVI_QUICK_PAYMENT_VIEW: ["REVERSE_GIRVI_QUICK_PAYMENT"],
  TENANT_TABLE: ["TENANT_VIEW"],
  EDIT_TENANT: ["TENANT_EDIT"],
  BRANCH_TABLE: ["BRANCH_VIEW"],
  EDIT_BRANCH: ["BRANCH_EDIT"],
  SCHEME_PLAN_VIEW: ["SCHEME_PLAN_VIEW"],
  SCHEME_PLAN_ADD: ["SCHEME_PLAN_ADD"],
  SCHEME_PLAN_EDIT: ["SCHEME_PLAN_EDIT"],
  SCHEME_VIEW: ["SCHEME_VIEW"],
  SCHEME_ADD: ["SCHEME_ADD"],
  SCHEME_EDIT: ["SCHEME_EDIT"],

  // New -> Legacy
  DASHBOARD_VIEW: ["DASHBOARD"],
  DAILY_PRICE_VIEW: ["DAILY_PRICE"],
  DAILY_PRICE_ADD: ["DAILY_PRICE"],
  METAL_GROUP_VIEW: ["METAL_GROUP"],
  METAL_GROUP_ADD: ["METAL_GROUP"],
  METAL_GROUP_EDIT: ["METAL_GROUP"],
  ITEM_CATEGORY_VIEW: ["ITEM_CATEGORY"],
  ITEM_CATEGORY_ADD: ["ITEM_CATEGORY"],
  ITEM_CATEGORY_EDIT: ["ITEM_CATEGORY"],
  PRODUCT_GROUP_VIEW: ["PRODUCT_GROUP"],
  PRODUCT_GROUP_ADD: ["PRODUCT_GROUP"],
  PRODUCT_GROUP_EDIT: ["PRODUCT_GROUP"],
  BANK_VIEW: ["BANK"],
  BANK_ADD: ["BANK"],
  BANK_EDIT: ["BANK"],
  CAPITAL_INVESTMENT_VIEW: ["CAPITAL_INVESTMENT_TABLE"],
  CAPITAL_INVESTMENT_ADD: [],
  CAPITAL_INVESTMENT_EDIT: ["EDIT_CAPITAL_INVESTMENT"],
  CUSTOMER_VIEW: ["CUSTOMER"],
  CUSTOMER_ADD: ["CUSTOMER"],
  CUSTOMER_EDIT: ["CUSTOMER"],
  SUPPLIER_VIEW: ["SUPPLIER", "KARIGAR"],
  SUPPLIER_ADD: ["SUPPLIER", "KARIGAR"],
  SUPPLIER_EDIT: ["SUPPLIER", "KARIGAR"],
  PRODUCT_VIEW: ["STOCK_TABLE", "STOCK"],
  PRODUCT_ADD: ["ADD_STOCK", "STOCK", "BULK_STOCK"],
  PRODUCT_EDIT: ["EDIT_STOCK"],
  PURCHASE_VIEW: ["PURCHASE_TABLE", "PURCHASE"],
  PURCHASE_ADD: ["ADD_PURCHASE"],
  PURCHASE_EDIT: ["EDIT_PURCHASE"],
  SALES_VIEW: ["SALES", "INVOICE"],
  SALES_ADD: ["SALES"],
  SALES_EDIT: ["EDIT_INVOICE", "SALES"],
  SALES_DELETE: ["SALES"],
  // Wholesale has no legacy aliases — only ERP codes WHSALE_*
  WHSALE_VIEW: [],
  WHSALE_ADD: [],
  WHSALE_EDIT: [],
  WHSALE_DELETE: [],
  CUSTOM_ORDER_VIEW: ["CUSTOM_ORDER_ENTRY_TABLE"],
  CUSTOM_ORDER_ADD: ["CUSTOM_ORDER_ENTRY"],
  CUSTOM_ORDER_EDIT: ["EDIT_CUSTOM_ORDER_ENTRY", "ORDER_CANCEL"],
  REPAIRING_ORDER_VIEW: ["REPAIRING_ORDER"],
  REPAIRING_ORDER_ADD: ["REPAIRING_ORDER_ENTRY"],
  REPAIRING_ORDER_EDIT: ["EDIT_REPAIRING_ORDER"],
  JANGAD_VIEW: ["JANGAD"],
  JANGAD_ADD: ["ADD_JANGAD"],
  JANGAD_EDIT: ["EDIT_JANGAD"],
  OLD_METAL_PURCHASE_VIEW: ["METAL_PURCHASE_TABLE"],
  OLD_METAL_PURCHASE_ADD: ["ADD_OLD_PURCHASE"],
  OLD_METAL_PURCHASE_EDIT: ["EDIT_OLD_PURCHASE"],
  REFINERY_VIEW: ["REFINERY"],
  REFINERY_ADD: ["ADD_REFINERY"],
  REFINERY_EDIT: ["EDIT_REFINERY"],
  CASH_BANK_VIEW: ["CASHBOOK_SETTLEMENT", "BANKBOOK_SETTLEMENT"],
  CASH_BANK_ADD: ["CASHBOOK_SETTLEMENT", "BANKBOOK_SETTLEMENT"],
  CASH_BANK_EDIT: ["CASHBOOK_SETTLEMENT", "BANKBOOK_SETTLEMENT"],
  CUSTOMER_SETTLEMENT_ADD: [],
  CUSTOMER_SETTLEMENT_VIEW: [],
  CUSTOMER_SETTLEMENT_EDIT: [],
  SUPPLIER_SETTLEMENT_ADD: ["ADD_SETTLEMENT", "SUPPLIER"],
  KARIGAR_CONVERSION_ADD: ["KARIGAR_CONVERSION"],
  KARIGAR_CONVERSION_VIEW: ["KARIGAR_CONVERSION", "SUPPLIER"],
  WALKIN_ADD: ["CUSTOMER_ARRIVAL", "TEST_CUSTOMER_FORM"],
  CUSTOMER_ASSIGN_VIEW: ["CUSTOMER_ASSIGN"],
  CUSTOMER_ASSIGN_ADD: ["CUSTOMER_ASSIGN"],
  ORDER_QUEUE_VIEW: ["ORDER_QUEUE"],
  TENANT_VIEW: ["TENANT_TABLE"],
  TENANT_ADD: ["TENANT_TABLE"],
  TENANT_EDIT: ["EDIT_TENANT"],
  BRANCH_VIEW: ["BRANCH_TABLE"],
  BRANCH_ADD: ["BRANCH_TABLE"],
  BRANCH_EDIT: ["EDIT_BRANCH"],
  ROLE_VIEW: ["ROLE"],
  ROLE_ADD: ["ADD_ROLE"],
  ROLE_EDIT: ["EDIT_ROLE"],
  EMPLOYEE_VIEW: ["EMPLOYEE"],
  EMPLOYEE_EDIT: ["EDIT_EMPLOYEE"],
  OTHER_CHARGE_VIEW: ["OTHER_CHARGE"],
  OTHER_CHARGE_ADD: ["OTHER_CHARGE"],
  OTHER_CHARGE_EDIT: ["OTHER_CHARGE"],
};

// Map old slug-style permission keys to new ERP UPPER_SNAKE_CASE codes where they differ
export const ERP_PERMISSION_CODE_BY_SLUG = {
  girvi: "GIRVI_VIEW",
  girvitable: "GIRVI_VIEW",
  addgirvi: "GIRVI_ADD",
  editgirvi: "GIRVI_EDIT",
  girviquickpayment: "GIRVI_QUICK_PAYMENT_VIEW",
  girvibankdetails: "GIRVI_BANK_VIEW",
  girvibankledger: "GIRVI_BANK_LEDGER_VIEW",
  reversegirvi: "REVERSE_GIRVI_DASHBOARD_VIEW",
  reversegirvitable: "REVERSE_GIRVI_VIEW",
  addreversegirvi: "REVERSE_GIRVI_ADD",
  editreversegirvi: "REVERSE_GIRVI_EDIT",
  reversegirviquickpayment: "REVERSE_GIRVI_QUICK_PAYMENT_VIEW",
  // Wholesale routes → ERP codes
  whinvoice: "WHSALE_VIEW",
  whsales: "WHSALE_ADD",
  editwhsale: "WHSALE_EDIT",
  whsale: "WHSALE_VIEW",
  karigar: "SUPPLIER_VIEW",
  supplier: "SUPPLIER_VIEW",
  customer: "CUSTOMER_VIEW",
  product_assorting: "PRODUCT_ASSORTING_VIEW",
  stock_table: "PRODUCT_VIEW",
  dashboard: "DASHBOARD_VIEW",
  daily_price: "DAILY_PRICE_VIEW",
  other_charge: "OTHER_CHARGE_VIEW",
  other_charges: "OTHER_CHARGE_VIEW",
  // Scheme
  SCHEME_PLAN_VIEW: "SCHEME_PLAN_VIEW",
  SCHEME_PLAN_ADD: "SCHEME_PLAN_ADD",
  SCHEME_PLAN_EDIT: "SCHEME_PLAN_EDIT",
  SCHEME_VIEW: "SCHEME_VIEW",
  SCHEME_ADD: "SCHEME_ADD",
  SCHEME_EDIT: "SCHEME_EDIT",
};

// Get all permissions from ERP auth store
export const getUserPermissions = () => {
  const perms = getErpPermissions();
  return perms && typeof perms === "object" ? perms : null;
};

// Resolve a PERMISSIONS.* slug (like "daily_price") to ERP code ("DAILY_PRICE")
export const resolveErpPermissionCode = (pageKey) => {
  const slug = String(pageKey || "").trim();
  if (!slug) return null;

  // Prefer explicit mapping when provided
  if (ERP_PERMISSION_CODE_BY_SLUG[slug]) {
    return ERP_PERMISSION_CODE_BY_SLUG[slug];
  }

  // Default: convert slug to UPPER_SNAKE_CASE (matches your ERP permission keys)
  return slug.toUpperCase();
};

/** Codes the ERP rejects — never include in create/update permission_codes. */
export const EXCLUDED_ERP_PERMISSION_CODES = new Set([
  "EMPLOYEE_ADD",
  "BILL_TYPE",
]);

/** Drop invalid / rejected ERP permission codes before API send. */
export const sanitizePermissionCodes = (codes = []) =>
  (Array.isArray(codes) ? codes : [])
    .map((c) => String(c || "").trim().toUpperCase())
    .filter((c) => c && !EXCLUDED_ERP_PERMISSION_CODES.has(c));

/** Convert UI boolean permission map (keyed by PERMISSIONS slugs) → ERP code list. */
export const permissionBoolMapToCodes = (boolMap = {}) => {
  const codes = new Set();
  Object.entries(boolMap || {}).forEach(([slug, on]) => {
    if (!on) return;
    const code = resolveErpPermissionCode(slug);
    if (code && !EXCLUDED_ERP_PERMISSION_CODES.has(String(code).toUpperCase())) {
      codes.add(code);
    }
  });
  return Array.from(codes);
};

/** Convert ERP code list → UI boolean map keyed by PERMISSIONS slugs. */
export const permissionCodesToBoolMap = (codes = [], base = {}) => {
  const set = new Set(
    (Array.isArray(codes) ? codes : []).map((c) => String(c).toUpperCase()),
  );
  const next = { ...base };
  Object.values(PERMISSIONS).forEach((slug) => {
    const code = resolveErpPermissionCode(slug);
    next[slug] = code ? set.has(code) : false;
  });
  return next;
};

/** Convert login/me `permissions: { CODE: 0|1 }` → UI boolean map. */
export const erpPermissionsObjectToBoolMap = (erpPerms = {}, base = {}) => {
  const next = { ...base };
  Object.values(PERMISSIONS).forEach((slug) => {
    const code = resolveErpPermissionCode(slug);
    next[slug] = code ? erpPerms?.[code] === 1 : false;
  });
  return next;
};

const isPermissionFlagOn = (value) =>
  value === 1 || value === true || value === "1";

const permissionCodesListIncludes = (codes, code) => {
  if (!Array.isArray(codes) || !code) return false;
  const want = String(code).toUpperCase();
  return codes.some((c) => String(c || "").trim().toUpperCase() === want);
};

// Check if user has permission for a specific page/action (ERP 1/0 flags with alias fallbacks)
export const hasPermission = (pageKey) => {
  const perms = getErpPermissions();
  const code = resolveErpPermissionCode(pageKey);
  if (!code) return false;

  const authUser = getErpAuthState()?.user;
  const userCodes = authUser?.permission_codes;

  // Direct check on permissions map
  if (perms && typeof perms === "object" && !Array.isArray(perms)) {
    if (
      isPermissionFlagOn(perms[code]) ||
      isPermissionFlagOn(perms[pageKey]) ||
      (code === "RATECUT_VIEW" && isPermissionFlagOn(perms["RATECUT_view"])) ||
      (code === "RATECUT_view" && isPermissionFlagOn(perms["RATECUT_VIEW"]))
    ) {
      return true;
    }

    // If the permission key is explicitly defined and set to 0 (denied),
    // do NOT fall back to a broader parent permission (e.g., CUSTOMER_ADD: 0 should not inherit CUSTOMER: 1)
    const isExplicitlyDenied =
      (perms[code] !== undefined && !isPermissionFlagOn(perms[code])) ||
      (perms[pageKey] !== undefined && !isPermissionFlagOn(perms[pageKey]));

    if (!isExplicitlyDenied) {
      // Check aliases / fallbacks only when the key wasn't explicitly denied
      const fallbacks =
        PERMISSION_FALLBACKS[code] ||
        PERMISSION_FALLBACKS[String(pageKey)] ||
        PERMISSION_FALLBACKS[String(pageKey).toUpperCase()];
      if (Array.isArray(fallbacks)) {
        for (const fb of fallbacks) {
          if (isPermissionFlagOn(perms[fb])) {
            return true;
          }
        }
      }
    }
  }

  // Some sessions only expose enabled codes as an array on the user
  if (permissionCodesListIncludes(userCodes, code)) {
    return true;
  }
  if (Array.isArray(userCodes)) {
    const fallbacks =
      PERMISSION_FALLBACKS[code] ||
      PERMISSION_FALLBACKS[String(pageKey)] ||
      PERMISSION_FALLBACKS[String(pageKey).toUpperCase()];
    if (Array.isArray(fallbacks)) {
      for (const fb of fallbacks) {
        if (permissionCodesListIncludes(userCodes, fb)) return true;
      }
    }
  }

  return false;
};
